import React from "react";
import { CheckIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { MOCKUP_URL } from "../data/offer";
import { volumes } from "../data/content";
export function Volumes() {
  return <section className="bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-346" data-mp="184wv8qrkxgbp">
      <div className="mx-auto max-w-6xl" data-id="element-347" data-mp="1c5gtjxnw2pzf">
        <h2 className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-348" data-mp="1c6a0aymulfhk">
          Everything you need to organize perimenopause cases in one practical collection
        </h2>
        <img src={MOCKUP_URL} alt="All six volumes of the Perimenopause Clinical Decision Roadmap" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-349" data-mp="24rs15s9wxr5q" />

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-350" data-mp="1vrmx9s3xhawb">
          {volumes.map((v, i) => <article key={v.title} className="flex flex-col rounded-3xl bg-brand-50 p-6 md:p-8" data-id="element-351" data-mp="fdwow95s00gv" data-mpi={i}>
              <span className="w-fit rounded-md bg-brand-700 px-2.5 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-352" data-mp="kfm3fys7iw9p">
                Volume {i + 1}
              </span>
              <h3 className="mt-4 text-xl font-extrabold leading-snug text-brand-900 md:text-2xl" data-id="element-353" data-mp="3jamy0je0jz2x">{v.title}</h3>
              <p className="mt-2 text-base font-medium text-muted" data-id="element-354" data-mp="229rttldbtd6">{v.tagline}</p>
              <p className="mt-5 text-sm font-bold text-ink" data-id="element-355" data-mp="3t6gl2wpczayy">Inside, you'll find:</p>
              <ul className="mt-3 space-y-2.5" data-id="element-356" data-mp="b0ldribai2za">
                {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-base text-ink" data-id="element-357" data-mp="63br2afac5f5">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-358" data-mp="krzmmgp4sf53" />
                    {item}
                  </li>)}
              </ul>
              <div className="mt-auto pt-6" data-id="element-359" data-mp="trcvb75fkzor">
                <p className="rounded-2xl bg-white p-4 text-sm leading-relaxed text-ink" data-id="element-360" data-mp="tse9vllno4b8">
                  <strong className="text-brand-700" data-id="element-361" data-mp="psdthvezxj1j">Your practical outcome:</strong> {v.outcome}
                </p>
              </div>
            </article>)}
        </div>

        <SectionCTA label="Unlock all 6 clinical volumes now" data-id="element-362" data-mp="11tlu72vrbukb" />
      </div>
    </section>;
}